import { createContext, useContext, useEffect, useRef, useState } from 'react';

import { MSG } from '../shared';
import { socket } from '../socket.js';
import { publish } from './events';

function UseProvideSocket() {
    const refSocket = useRef(socket);

    const [connected, setConnected] = useState(false);

    useEffect(() => {
        refSocket.current.on('connect', () => {
            setConnected(true);
        });

        refSocket.current.on('disconnect', () => {
            setConnected(false);
        });

        BASIC_MESSAGES.forEach((msg) => {
            refSocket.current.on(msg, (res) => {
                publish(msg, res);
            });
        });
    }, []);

    return {
        connected,
        socket: refSocket.current
    };
}

function ProvideSocket({ children }) {
    const useProvideSocket = UseProvideSocket();

    return <SocketContext.Provider value={useProvideSocket}>{children}</SocketContext.Provider>;
}

function UseSocket() {
    return useContext(SocketContext);
}

const SocketContext = createContext();
const BASIC_MESSAGES = [
    MSG.signOut,
    MSG.create.list,
    MSG.update.list,
    MSG.create.employee,
    MSG.update.employee,
    MSG.create.parent,
    MSG.update.parent,
    MSG.create.program,
    MSG.update.program,
    MSG.create.service.individual,
    MSG.update.service.individual,
    MSG.create.service.group,
    MSG.update.service.group,
    MSG.create.service.program,
    MSG.update.service.program
];

export { UseSocket as useSocket };

export default ProvideSocket;
